<template>
    <div class="window-wrapper window-forgot">
        <div class="window-overlay"></div>
        <div class="window">
            <div class="window-inner">
                <div class="window-left">

                </div>
                <div class="window-right">
                    <div class="window-right-inner">
                        <div class="logo">
                            <Logo/>
                        </div>
                        <div class="title">Забыли пароль?</div>
                        <div class="form-desc">Введите email, указанный при регистрации</div>
                        <div class="form">

                            <fieldset class="form-field-input filled"
                                      v-bind:class="{'error-field' : errors.has('email') | requestStatus === requestStatuses.error}">
                                <label>
                                    <input name="email"
                                           ref="email"
                                           v-model.trim="email"
                                           type="text"
                                           autocomplete="off"
                                           required
                                           @input="requestStatus = requestStatuses.wait"
                                           v-validate="'required|email'"
                                           @keyup.enter="recoverPassword">
                                    <div class="label-text">Email</div>
                                    <div v-show="errors.has('email')" class="msg-form msg-error-field">{{
                                        errors.first('email') }}
                                    </div>
                                    <div v-show="requestStatus === requestStatuses.error"
                                         class="msg-form msg-error-field">
                                        Неверно введен email
                                    </div>
                                </label>
                            </fieldset>

                            <div class="button-block">
                                <button class="button button-dark"
                                        :disabled="isBlocked || pressed"
                                        @click="recoverPassword">Восстановить пароль</button>
                            </div>

                            <div v-show="this.requestStatus === this.requestStatuses.success" class="msg msg-send-ok">На Вашу почту выслана ссылка для восстановления пароля</div>

                        </div>

                    </div>
                </div>
            </div>
            <button class="btn-close">
                <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M1 1L27 27M27 1L1 27" stroke="black"/></g></svg>
            </button>
        </div>
    </div>
</template>



<script>
    import Logo from "../icons/Logo";
    import {Validator} from 'vee-validate';
    import constants from '@/constants';

    const requestStatusesInternal = Object.freeze({
        wait: 0,
        success: 1,
        error: 2
    });

    export default {
        name: 'PasswordForgot',
        components: {Logo},

        data() {
            return {
                email:'',
                requestStatus: requestStatusesInternal.wait,
                pressed: false,
                requestStatuses: requestStatusesInternal
            }
        },



        computed: {
            isBlocked() {
                return !(Object.keys(this.fields).every(key => this.fields[key].valid))
            }
        },

        methods: {
            async recoverPassword() {
                if (this.isBlocked || this.pressed) {
                    return;
                }
                this.pressed = true;
                try {

                    await this.$store.dispatch('refreshPassword', {email:this.email, lang:this.$ml.current});
                    this.requestStatus = requestStatusesInternal.success;
                } catch(error) {
                    this.requestStatus = requestStatusesInternal.error;
                    this.pressed = false;
                }
            }
        }



    }
</script>